import { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import Button from '../../../../components/Button/Button';
import { MASK } from '../../../../constants/mask';

/**
 * ÐÐ°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾ (Freedom, Ð¿.4.1 ÑÑÐµÐ¼Ñ v5).
 *
 * ÐÐ»Ñ ÑÐ¸Ð¿Ð¾Ð² THRIFT* Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸, Ð¿Ð¾ÐºÐ° Ð½Ðµ
 * Ð¿Ð¾Ð»ÑÑÐ¸Ñ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°: Ð¾Ð½ ÑÐ²ÐµÑÑÐµÑ ÐÐÐ Ñ Ð±Ð°Ð·Ð¾Ð¹ ÐÐÐ Ð¿Ð¾ VIN Ð¸ ÑÐ»ÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÑ Ð¡ÐÐ¡
 * Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ñ. ÐÐ¾ÑÑÐ´Ð¾Ðº Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½: ÑÐ½Ð°ÑÐ°Ð»Ð° owner, Ð·Ð°ÑÐµÐ¼
 * re-register/confirm.
 *
 * [sent] â Ð²Ð»Ð°Ð´ÐµÐ»ÐµÑ ÑÐ¶Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½ (appeal.ownerSentAt Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½). Ð¢Ð¾Ð³Ð´Ð° Ð²Ð¼ÐµÑÑÐ¾
 * ÑÐ¾ÑÐ¼Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÑÐ°ÑÑÑ, ÑÐ¼ÐµÐ½Ñ Ð½Ð¾Ð¼ÐµÑÐ° Ð¸ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸:
 * Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐº Ð½ÑÐ¶ÐµÐ½ Ð¿Ð¾ÑÐ»Ðµ ÑÑÐºÐ° OWNER_ON_REVISION, ÐºÐ¾Ð³Ð´Ð° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð¸Ð»
 * Ð´Ð°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð² Ð¦ÐÐ.
 */
const FreedomOwnerInfo = ({ onSubmit, onChangePhone, onRestart, loading, sent, revisionReason }) => {
  const [phoneFormOpen, setPhoneFormOpen] = useState(false);

  if (sent) {
    return (
      <div style={{ marginBottom: 20 }}>
        <HookForm title={'ÐÐ»Ð°Ð´ÐµÐ»ÐµÑ Ð°Ð²ÑÐ¾'} grid={{ display: 'grid', gap: 20 }} inputs={[]} onSubmit={() => {}} />
        <p style={{ marginTop: -10, marginBottom: 12 }}>
          {revisionReason
            ? `ÐÐ°Ð½Ðº Ð²ÐµÑÐ½ÑÐ» Ð´Ð°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð½Ð° Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÑ: ${revisionReason}`
            : 'ÐÐ°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ð² Ð±Ð°Ð½Ðº. ÐÐ»Ð°Ð´ÐµÐ»ÑÑÑ Ð½Ð°Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð¡ÐÐ¡ Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ñ.'}
        </p>

        {/*
          Ð¡Ð¼ÐµÐ½Ð° Ð½Ð¾Ð¼ÐµÑÐ° (Ð¿.4.2 ÑÑÐµÐ¼Ñ) â Ð½Ð° ÑÐ»ÑÑÐ°Ð¹, ÐºÐ¾Ð³Ð´Ð° Ð²Ð»Ð°Ð´ÐµÐ»ÐµÑ Ð¿ÑÐ¾Ð´Ð¸ÐºÑÐ¾Ð²Ð°Ð»
          Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¸ Ð¡ÐÐ¡ Ð½Ðµ Ð´Ð¾ÑÐ»Ð°. ÐÐ°Ð½Ðº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ PATCH ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð¾ Ð½Ð°ÑÐ°Ð»Ð°
          Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°; ÐµÑÐ»Ð¸ ÑÐ¶Ðµ Ð¿Ð¾Ð·Ð´Ð½Ð¾ â Ð²ÐµÑÐ½ÑÑ Ð¿Ð¾Ð½ÑÑÐ½ÑÑ Ð¾ÑÐ¸Ð±ÐºÑ.
          ÐÐµÑÐµÐ·Ð°Ð¿ÑÑÐº Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÑÐ¾Ñ ÑÐ»ÑÑÐ°Ð¹ Ð½Ðµ Ð»ÐµÑÐ¸Ñ: Ð¾Ð½ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ Ð½Ð¾Ð¼ÐµÑ.
        */}
        {phoneFormOpen ? (
          <HookForm
            grid={{ display: 'grid', gap: 20 }}
            action={'ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð½Ð¾Ð¼ÐµÑ'}
            inputs={[
              {
                label: 'ÐÐ¾Ð²ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°',
                name: 'mobilePhone',
                type: 'phone',
                mask: MASK.PHONE,
                inputMode: 'numeric',
                rules: {
                  required: true,
                  validate: (value) => (value || '').replace(/\D/g, '').length === 11,
                },
              },
            ]}
            onSubmit={(values) => {
              onChangePhone(values);
              setPhoneFormOpen(false);
            }}
            loading={loading}
            // HookForm Ð²ÑÐ·ÑÐ²Ð°ÐµÑ backHandler() Ð²Ð¾ Ð²ÑÐµÐ¼Ñ ÑÐµÐ½Ð´ÐµÑÐ° Ð¸ ÑÐµÐ½Ð´ÐµÑÐ¸Ñ
            // ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ ÐºÐ°Ðº JSX â ÑÑÐ´Ð° Ð½ÑÐ¶ÐµÐ½ ÑÐ»ÐµÐ¼ÐµÐ½Ñ, Ð° Ð½Ðµ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº.
            backHandler={() => (
              <Button
                type={'button'}
                text={'ÐÑÐ¼ÐµÐ½Ð°'}
                onClick={() => setPhoneFormOpen(false)}
                style={{ color: '#BABABA', border: '1px solid #BABABA' }}
              />
            )}
          />
        ) : (
          // ÐÐ±Ðµ ÐºÐ½Ð¾Ð¿ÐºÐ¸ â ÑÐ°Ð²Ð½Ð¾Ð·Ð½Ð°ÑÐ½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¹
          // Ð²Ð¸Ð´ Ð¸ Ð¾Ð±ÑÐ°Ñ ÑÐ¸ÑÐ¸Ð½Ð°: ÑÐµÑÑÐ¹ ÐºÐ¾Ð½ÑÑÑ ÑÐ¸ÑÐ°Ð»ÑÑ ÐºÐ°Ðº Â«Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¾Â».
          // type="button" Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½: Button Ð±ÐµÐ· type ÑÐµÐ½Ð´ÐµÑÐ¸Ñ <button> Ð±ÐµÐ·
          // Ð°ÑÑÐ¸Ð±ÑÑÐ°, Ð° ÑÐ°ÐºÐ°Ñ ÐºÐ½Ð¾Ð¿ÐºÐ° Ð²Ð½ÑÑÑÐ¸ ÑÐ¾ÑÐ¼Ñ ÑÑÐ¸ÑÐ°ÐµÑÑÑ submit â ÐºÐ»Ð¸Ðº
          // ÑÑÐ¾Ð´Ð¸Ð» Ð² ÑÐ°Ð±Ð¼Ð¸Ñ ÑÐ¾ÑÐ¼Ñ Ð²Ð¼ÐµÑÑÐ¾ onClick, Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ° Â«Ð½Ðµ Ð½Ð°Ð¶Ð¸Ð¼Ð°Ð»Ð°ÑÑÂ».
          <div style={{ display: 'grid', gap: 10, justifyItems: 'start' }}>
            <Button
              type={'button'}
              text={'ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°'}
              onClick={() => setPhoneFormOpen(true)}
              style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)', width: 320 }}
            />
            <Button
              type={'button'}
              text={'ÐÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°'}
              onClick={onRestart}
              disabled={loading}
              style={{ color: 'rgb(73, 65, 54)', border: '1px solid rgb(73, 65, 54)', width: 320 }}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 20 }}>
      <HookForm
        title={'ÐÐ»Ð°Ð´ÐµÐ»ÐµÑ Ð°Ð²ÑÐ¾'}
        subtitle={() => (
          <p style={{ marginBottom: 10 }}>
            ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ Ð°Ð²ÑÐ¾: Ð±Ð°Ð½Ðº ÑÑÐµÐ±ÑÐµÑ Ð´Ð°Ð½Ð½ÑÐµ ÑÐµÐºÑÑÐµÐ³Ð¾ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð´Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ Ð¿ÐµÑÐµÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸. ÐÐ»Ð°Ð´ÐµÐ»ÑÑÑ Ð¿ÑÐ¸Ð´ÑÑ
            Ð¡ÐÐ¡ Ð´Ð»Ñ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ñ.
          </p>
        )}
        grid={{ display: 'grid', gap: 20 }}
        action={'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð² Ð±Ð°Ð½Ðº'}
        inputs={[
          {
            label: 'ÐÐÐ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°',
            name: 'iin',
            mask: MASK.IIN,
            inputMode: 'numeric',
            rules: {
              required: true,
              validate: (value) => (value || '').replace(/\D/g, '').length === 12,
            },
          },
          {
            label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°',
            name: 'mobilePhone',
            type: 'phone',
            mask: MASK.PHONE,
            inputMode: 'numeric',
            rules: {
              required: true,
              validate: (value) => (value || '').replace(/\D/g, '').length === 11,
            },
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
      />
    </div>
  );
};

export default FreedomOwnerInfo;
